import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme: { spacing } }) => css`
    padding: ${spacing.level6} ${spacing.level6} 0;
    gap: ${spacing.level2};
  `}

  @media (max-width: 768px) {
    ${({ theme: { spacing } }) => css`
      padding: ${spacing.level5} ${spacing.level4} 0;
    `}
  }
`;
